import { Link } from "react-router-dom";
import { LegalPageLayout } from "@/components/shared/LegalPageLayout";
import { useSeo } from "@/components/shared/useSeo";

const UPDATED = "8 Ağustos 2026";

export default function GizlilikPolitikasi() {
  useSeo({
    title: "Gizlilik Politikası | Sistem Elektrik ve Mühendislik",
    description: "Sistem Elektrik ve Mühendislik internet sitesinin gizlilik ve kişisel veri işleme politikası.",
    canonical: "https://sistemmuhendislik.com/gizlilik-politikasi",
  });

  return (
    <LegalPageLayout
      eyebrow="GİZLİLİK"
      title="Gizlilik Politikası"
      description="Sistemmuhendislik.com ziyaret edildiğinde ve iletişim kanallarımız kullanıldığında bilgilerin nasıl ele alındığına ilişkin genel açıklama."
      updatedAt={UPDATED}
    >
      <h2>1. Kapsam</h2>
      <p>
        Bu Gizlilik Politikası, <strong>Sistem Elektrik ve Mühendislik</strong> markası altında İsa Şeker tarafından işletilen
        <strong> sistemmuhendislik.com</strong> internet sitesini ve site üzerinden kurulan iletişimi kapsar.
      </p>

      <h2>2. Doğrudan Paylaştığınız Bilgiler</h2>
      <p>
        İletişim formunu kullandığınızda ad-soyad, firma adı, telefon, e-posta, hizmet türü ve mesaj/proje açıklaması gibi tarafınızca girilen bilgiler alınabilir. Aynı şekilde telefon, e-posta veya WhatsApp üzerinden tarafınızca paylaşılan bilgiler de iletişimin yürütülmesi amacıyla işlenebilir.
      </p>

      <h2>3. Teknik Bilgiler ve Site Altyapısı</h2>
      <p>
        Siteye erişildiğinde barındırma, içerik sunumu ve güvenlik hizmetlerini sağlayan teknik altyapılar; IP adresi, tarayıcı/cihaz bilgileri, erişim zamanı ve hata/güvenlik kayıtları gibi teknik verileri kendi hizmetlerinin sunulması kapsamında işleyebilir.
      </p>
      <p>
        Site <strong>Netlify</strong> altyapısında barındırılmaktadır. İletişim formu kullanıldığında form gönderimi Netlify Forms üzerinden işlenir ve site sahibinin Netlify hesabında görüntülenebilir.
      </p>

      <h2>4. Harici İçerik ve Bağlantılar</h2>
      <p>
        Site tasarımında Google Fonts üzerinden sunulan yazı tipleri ve Unsplash üzerinden sunulan bazı görseller kullanılmaktadır. Bu kaynakların tarayıcınız tarafından doğrudan ilgili sağlayıcılardan istenmesi sırasında bağlantı bilgileriniz ilgili üçüncü taraflara iletilebilir. Bu hizmetlerin kendi gizlilik koşulları geçerlidir.
      </p>
      <p>
        WhatsApp butonuna tıklamanız hâlinde WhatsApp'ın harici hizmetine yönlendirilirsiniz. Bu yönlendirmeden sonra gerçekleşen veri işleme faaliyetleri WhatsApp/Meta'nın kendi politikalarına tabidir.
      </p>

      <h2>5. Analitik ve Reklam Takibi</h2>
      <p>
        Bu politikanın son güncelleme tarihi itibarıyla site kodunda Google Analytics, Meta Pixel, Hotjar, Microsoft Clarity veya benzeri reklam/ziyaretçi davranışı izleme araçları kullanılmamaktadır. Site, reklam veya davranışsal profil oluşturma amacıyla ziyaretçi takibi yapmamaktadır.
      </p>

      <h2>6. Verilerin Kullanım Amaçları</h2>
      <p>Toplanan bilgiler; iletişim taleplerini yanıtlamak, proje ve hizmet taleplerini değerlendirmek, teklif veya ön değerlendirme yapmak, iş ilişkisini yürütmek, site güvenliğini sağlamak ve yasal yükümlülükleri yerine getirmek amacıyla kullanılabilir.</p>

      <h2>7. Verilerin Paylaşılması ve Yurt Dışı İşleme</h2>
      <p>
        Veriler; hizmetin teknik olarak sunulması için gerekli barındırma, form, e-posta ve bilgi teknolojisi sağlayıcılarıyla; hukuken gerekli durumlarda yetkili kurum ve profesyonel danışmanlarla sınırlı şekilde paylaşılabilir.
      </p>
      <p>
        Netlify ve bazı harici içerik sağlayıcılarının yurt dışında bulunan altyapılarından yararlanılması nedeniyle teknik veriler veya iletişim formu verileri bakımından yurt dışı işleme/aktarım söz konusu olabilir. Kişisel verilerin yurt dışına aktarılması, KVKK'nın 9. maddesi ve ilgili düzenlemeler kapsamında ayrıca değerlendirilmesi gereken bir süreçtir.
      </p>

      <h2>8. Saklama ve Güvenlik</h2>
      <p>
        Bir iş ilişkisine dönüşmeyen iletişim talepleri, talebin sonuçlanmasından itibaren 1 yıl süreyle saklanabilir. Hukuki veya ticari bir ilişkinin doğması hâlinde ilgili kayıtlar mevzuattaki zorunlu süreler boyunca tutulabilir. Kişisel verilerin korunması için erişimin ihtiyaçla sınırlandırılması, hesap güvenliği ve süresi dolan kayıtların silinmesi gibi uygun teknik ve idari tedbirlerin uygulanması esastır.
      </p>

      <h2>9. Haklarınız ve İletişim</h2>
      <p>
        Genel sorularınız için <a href="mailto:isa@sistemmuhendislik.com">isa@sistemmuhendislik.com</a> adresinden bizimle iletişime geçebilirsiniz. KVKK'nın 11. maddesi kapsamındaki haklarınız ve resmi başvuru yöntemleri <Link to="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</Link>'nde ayrıntılı olarak açıklanmıştır.
      </p>

      <h2>10. Değişiklikler</h2>
      <p>
        Sitede kullanılan teknoloji, hizmet sağlayıcılar veya veri işleme faaliyetleri değişirse bu politika güncellenebilir. Güncel sürüm ve güncelleme tarihi bu sayfada yayımlanır.
      </p>
    </LegalPageLayout>
  );
}
